<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="日期">
              <a-range-picker
                v-model="queryParam.date"
                format="YYYY-MM-DD"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>
      <div class="table-page-wrapper">
        <a-pagination size="small" v-model="queryParam.pageNum" :pageSizeOptions="pageSizeOptions"
                      :pageSize="queryParam.pageSize"
                      :total="total"
                      :show-total="total => `共 ${total} 条`"
                      show-size-changer show-quick-jumper @change="pageChange" @showSizeChange="onShowSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { findLoanStatusCount } from '@/webpublicapi/order'
import vModal from '../modules/Modal';
import moment from 'moment'
import { getVipList } from '@/webpublicapi/vip'

const I18N_KEY = 'order.';
export default {
  name: 'loanStatusLoanCount',
  components: {
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visibleRepayUrlCard: false,
      repayUrl: '',
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        date: [moment().add('days', -7), moment().add('days', 0)],
        pageNum: 1, pageSize: 10
      },
      pageSizeOptions: ['10', '20', '30', '40'],

      loading: false,
      // 表头
      isorter: {
        column: 'd',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '用户 id',
          align: 'left',
          dataIndex: 'custInfoId'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'payChannel'
        },
        {
          title: '付款时间',
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: '付款金额',
          align: 'left',
          dataIndex: 'amount'
        },
        {
          title: '付款 id',
          align: 'left',
          dataIndex: 'payOutId'
        }
      ]
    },
  },
  created () {
    this.loadData(1)
  },
  methods: {
    pageChange(page, pageSize){
      this.queryParam.pageNum=page
      this.queryParam.pageSize=pageSize
      this.loadData()
    },
    onShowSizeChange(page, pageSize){
      this.queryParam.pageNum=page
      this.queryParam.pageSize=pageSize
      this.loadData()
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getVipList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data.rows
          this.total = res.data.total
        }else{
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { date } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: (date && date.length) ? this.transformTime(date[0]) : undefined,
        endDate : (date && date.length) ? this.transformTime(date[1]) : undefined,
      }
      delete data.date;
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      var that = this
    },
    changeModal (visible) {
        this.visible = visible;
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
